export const FILTER_ADD_ON_SELLING_OPTIONS_BY_PAYMENT_TYPE =
  'FILTER_ADD_ON_SELLING_OPTIONS_BY_PAYMENT_TYPE';

export const filterAddOnSellingOptionsByPaymentType = data => ({
  type: FILTER_ADD_ON_SELLING_OPTIONS_BY_PAYMENT_TYPE,
  payload: data
});
